import { put, takeEvery } from 'redux-saga/effects';
import request from 'utils/request';
import urls from 'utils/config';
import {
  fetchReminderSuccess,
  fetchReminderFailed
} from '../actions';
import { ReminderTypes } from '../types';
import { networkErrorHandler } from 'utils/errrorHandlers';

const { API_BASE_URL } = urls || {};

export function* fetchReminderSettings({ data }) {
  const url = `${API_BASE_URL}/reminders?page=${data.page}&size=${data.size}`;

  const response = yield request({
    method: 'get',
    url,
  });
  if (response.success) {
    yield put(fetchReminderSuccess(response.raw));
  } else {
    networkErrorHandler(response?.statusCode, `Failed to Fetch Reminder: ${response.message}`);
    yield put(fetchReminderFailed(response.message));
  }
}

export function* getReminderSettings() {
  yield takeEvery(ReminderTypes.FETCHING_REMINDER_SETTINGS, fetchReminderSettings);
}
